export default __webpack_public_path__ + "static/teamflow-c979ccc4268f26ea350db81192cc50e1.png";